/* 
*
*   This JS file ONLY has header and footer related JS to be loaded on every page
*   /js/structure.js
*   
*   Includes: Menu toggles, Mobile menu toggles, sticky banner, hero parallax, search toggle, language toggle
*
*   This file has NO dependencies and is vanilla JS.
*  Author: ABLE Dev
 */

export function structure () {

/* ----------------------
  NavBar flyout states
------------------------*/

const menuTotal = document.querySelector('.menu-square');
const menuBtn = document.querySelector('.menu-triple-hoverable');
const menuFloat = document.querySelector('.second-level');

if (menuTotal && menuBtn && menuFloat ) {
menuTotal.addEventListener('mouseenter', desktopHamburgerToggle, false); 
menuTotal.addEventListener('mouseleave', desktopHamburgerToggle, false);
menuTotal.addEventListener('touchstart', desktopHamburgerToggle, false); 
}

function desktopHamburgerToggle() {
  menuBtn.classList.toggle('open');
  menuFloat.classList.toggle('open');
};

/* ----------------------
  NavBar Search states
------------------------*/

const searchClick = document.querySelector('.search-btn-icon');
const searchClose = document.querySelector('.search-cross');
const searchBtn = document.querySelector('.search-btn');
const searchModal = document.querySelector('.search-modal');
var searchOpen = false;
if (searchClick) {
searchClick.addEventListener('click', () => {
  searchScrollToggle();
  if(!searchOpen) {
    if (megaArray) {
      megaMenuClose();
    }
    document.querySelector('.search-input').focus();
    searchOpen = true;
  } else {
    searchOpen = false;
  }
});
}

function searchScrollToggle() {
  searchBtn.classList.toggle('open');
  searchModal.classList.toggle('open');
}

if (searchClose) {
searchClose.addEventListener('click', () => {
    document.querySelector('.search-input').value = '';
    searchScrollClose();
});
}


/* ----------------------
  Desktop and mobile Searc submit listeners
------------------------*/

const searchSubmit = document.querySelector('.search-icon');
const mobileSearchSubmit = document.getElementById('mobile-search-trigger');

// desktop search icon
if(searchSubmit) {
  searchSubmit.addEventListener('click', () => {
    document.getElementById('search').submit();
  });
}

// mobile search icon
if(mobileSearchSubmit) {
  mobileSearchSubmit.addEventListener('click', () => {
    document.getElementById('mobile-search').submit();
  });
}

// See below for window scroll listener //
function searchScrollClose() {
    searchBtn.classList.remove('open');
    searchModal.classList.remove('open');
    searchOpen = false
}

/* -----Footer language bar on/off states------------------------*/

const languageBtn = document.querySelector('.select-language')
const languageModal = document.querySelector('.list-language-container');
const languageCaret = document.querySelector('.language-caret');

if ( languageBtn && languageModal && languageCaret ) {
  languageBtn.addEventListener('click', footerLanguageToggle);
};

function footerLanguageToggle() {
  languageModal.classList.toggle('open');
  languageCaret.classList.toggle('open');
};

/* -----Header language bar on/off states----*/

const hLanguageTotal = document.querySelector('.header-language-toggle')
const hLanguageBtn = document.querySelector('.header-lang-btn');
const hLanguageFloat = document.querySelector('.languages-flyout');

if ( hLanguageTotal && hLanguageBtn && hLanguageFloat ) {
  hLanguageBtn.addEventListener('mouseenter', headerLanguageToggle );
  hLanguageBtn.addEventListener('mouseleave', headerLanguageToggle );
};

function headerLanguageToggle() {
  hLanguageBtn.classList.toggle('open');
  hLanguageFloat.classList.toggle('open');
}

/* -----Mobile Language Bar ----*/

const mLanguageBtn = document.querySelector('.mobile-language-toggle');

if ( mLanguageBtn ) {
  mLanguageBtn.addEventListener('click', mobileLanguageToggle );
};

function mobileLanguageToggle() {
  mLanguageBtn.classList.toggle('open');
}

/*---- Mobile nav below hero toggle ----*/

const mHeroNavBtn = document.querySelector('#mobile-hero-nav-toggle')

if ( mHeroNavBtn ) {
  mHeroNavBtn.addEventListener('click', mobileHeroNavToggle );
};

function mobileHeroNavToggle() {
  mHeroNavBtn.classList.toggle('open');
};


/* Mobile Search Bar --- */

var mSearchCross = null;
if ( mSearchCross = document.querySelector('.mobile-search-cross') ) {
  let mModalSearch = document.querySelector('.mobile-modal-search');
  mSearchCross.addEventListener('click', () => {
    mModalSearch.value="";
    mModalSearch.focus();
  })
};

/* ----------------------

Mobile toggle

------------------------*/

const mobileBtnToggle = document.querySelector('.mobile-toggle');
const mobileBtn = document.querySelector('.mobile-bars');
const mobileMenu = document.getElementById('mobile-modal');
const mobileLogo = document.querySelector('.menu-logo');
const mobileBanner = document.querySelector('.header-holder');
const mobileBody = document.body;

const mediaQueryList = window.matchMedia('(min-width: 768px)');

// Standard Toggle & if scales out while on beyond mobile size
if (mobileBtnToggle) {
  mobileBtnToggle.addEventListener('click', mobileMenuBtnToggle);
  mediaQueryList.addEventListener('change', event => {
    if (event.matches && mobileMenu.classList.contains('open')) {
      mobileMenuBtnToggle();
    }
  })
};

function mobileMenuBtnToggle() {
  mobileBtn.classList.toggle('open');
  mobileMenu.classList.toggle('open');
  mobileLogo.classList.toggle('green');
  mobileBanner.classList.toggle('green');
  mobileBody.classList.toggle('no-overflow');
}

/*--- Sidebar citations toggle --- */

const citationBtn = document.getElementById('btn-sidebar-citations');
const citationRoot = document.getElementById('sidebar-citation-wrapper');

if ( citationBtn ) {
  citationBtn.addEventListener('click', citationToggle );
  document.addEventListener('click', clickOutsideTab );
};

function clickOutsideTab(e) {
  if (citationBtn.classList.contains('open')) {
    var isClickInsideElement = citationRoot.contains(e.target);
    if (!isClickInsideElement) {
      citationToggle();
    }
  }
}

function citationToggle() {
  citationBtn.classList.toggle('open');
};

let citationTabs = document.getElementsByClassName('btn-citation-tab');
let tabArray = Array.from(citationTabs);

if ( tabArray ) {
  tabArray.forEach(tab => {
    tab.addEventListener('click', citationTabToggle );
  });
};

function citationTabToggle(e) {
  // Get Data attribute - then get element by name and change it's value while turning off the rest
  for (let i = 0; i < tabArray.length; i++) {
    tabArray[i].classList.remove('open');
    let option = tabArray[i].dataset.option;
    document.getElementById(option).classList.remove('open');
  }
  e.target.classList.add('open');
  let option = e.target.dataset.option;
  document.getElementById(option).classList.add('open');
}


// if Citations exist - set-up listeners for auto higlight
let citationTextBlocks = document.getElementsByClassName('citation-text');
let citationTextArray = Array.from(citationTextBlocks);

if (citationTextArray) {
  citationTextArray.forEach(citation => {
    citation.addEventListener('click', selectText );
  });
}

function selectText(e) {
  let range = document.createRange();
  let selection = window.getSelection();
  range.selectNodeContents(e.target);
  selection.removeAllRanges();
  selection.addRange(range);
}


let megaMobileButtons = document.getElementsByClassName('mobile-accordian-trigger');
let megaMobileArray = Array.from(megaMobileButtons);

if ( megaMobileArray ) {
  megaMobileArray.forEach(button => {
    button.addEventListener('click', megaMobileToggle );
  });
};

function megaMobileToggle(e) {
  if (e.target.parentNode.classList.contains('open')) {
    megaMobileClose();
  } else {
    megaMobileClose();
    e.target.parentNode.classList.toggle('open');
  }
}

function megaMobileClose() {
  for (let i = 0; i < megaMobileArray.length; i++) {
    console.log(megaMobileArray[i]);
    megaMobileArray[i].parentNode.classList.remove('open');
  }
}

/* --------------- Mega Menu ---------*/

let megaMenuButtons = document.getElementsByClassName('mega-menu');
let megaArray = Array.from(megaMenuButtons);

if ( megaArray ) {
  let closeDomElement = document.querySelector('.header-overall-wrapper');
  megaArray.forEach(button => {
    button.addEventListener('click', megaMenuToggle );
  });
  document.addEventListener('click', (e) => {
    if(!closeDomElement.contains(e.target)) {
      megaMenuClose();
    }
  })
};

function megaMenuToggle(e) {
  // Only 1 menu items open at a time with toggle option and close seach if open checks if it should delay open or not if other menu item is open
  if(searchOpen) {
    searchScrollClose()
  }
  if (e.target.classList.contains('open')) {
    megaMenuClose();
  } else {
    let isOpen = false;
    for (let i = 0; i < megaArray.length; i++) {
      if (megaArray[i].classList.contains('open')) {
        isOpen = true;
      };
    }
    megaMenuClose();
    if (isOpen) {
      let timer = setTimeout(() => {e.target.classList.toggle('open')}, 500);
    } else {
      e.target.classList.toggle('open');
    }
    
  }
}

function megaMenuClose() {
  for (let i = 0; i < megaArray.length; i++) {
    megaArray[i].classList.remove('open');
  }
}

/* --------------- Mobile Accordion ---------*/

document.querySelectorAll('.nn-about-flyout').forEach(item => {
  item.onclick = function() {
    item.classList.toggle('rotated');
    item.parentNode.classList.toggle('rotated');
  }
});

/* --------------- Facet menu ---------*/

document.querySelectorAll('.control-level').forEach(item => {
  item.onclick = function() {
    item.parentNode.classList.toggle('open');
    let controlIcon = item.getElementsByClassName('facet-control-chevron');
    if ( controlIcon ) {
      controlIcon[0].classList.toggle('open');
    }
  }
});


/* ======================

SCROLL CONTROL

======================= */



if (document.getElementById('sticky-banner')) {
  var firstScroll = false;
  var header = document.getElementById('sticky-banner');
  var sticky = header.offsetTop;
}

window.onscroll = function() {

  if (!firstScroll && sticky) {
    if (window.pageYOffset > sticky) {
      stickyheaderFunction()
      firstScroll = true;
    } 
  }
  
  if (firstScroll && sticky) {
    if ( window.pageYOffset < sticky ) {
        stickyheaderFunction()
      firstScroll = false;
    }
  }

  if(searchOpen) {
    searchScrollClose()
  }
  
  // Test if their is Parallax called for
  if(document.querySelector('.hero-parallax')) {
    bgHeroParallax()
  }
};


// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position

let stickyHeaderOn = false;
function stickyheaderFunction() {

  // Get items to change
  //const subtext = document.querySelector('.available24hours-text');
  const calltext = document.querySelector('.banner-call');

  if (!stickyHeaderOn) {
    header.classList.add("stickyon");
    //subtext.classList.add("stickyoff");
    calltext.classList.add("stickyformat");
    stickyHeaderOn = true;
  } else {
    header.classList.remove("stickyon");
    //subtext.classList.remove("stickyoff");
    calltext.classList.remove("stickyformat");
    stickyHeaderOn = false;    
  }
}; 


/*-----------------------------

Search page toggles

-----------------------------*/

var searchPageClose = document.querySelector('.main-search-close');
var searchPageSearch = document.querySelector('.main-search-icon');;

if ( document.querySelector('.main-search-input') ) {
  searchPageClose.addEventListener('click', () => {
      document.querySelector('.main-search-input').value = '';
  });
  searchPageSearch.addEventListener('click', () => {
      document.getElementById('main-search').submit();
  });
}

/*=============================

PARALLAX

==============================*/

// CALL FOR THIS FUNCTION IS INCLUDED IN WINDOW.ONSCROLL LISTENER
// if the class .header-background-parralax exists, onscroll will call this function. 
function bgHeroParallax() { 
  
  var bgParallax = document.querySelector('.hero-parallax');

  // change the divider to change the speed of movement
  var yPos = window.pageYOffset / 10;
  // reviser the value to negative to that the image scrolls down
  yPos = -yPos
  // create a percent value
  var coords = 50 + yPos + '%';
  // move the image
  bgParallax.style.backgroundPositionY = coords;

}
};
